import format from 'date-fns/format';
import formatDistance from 'date-fns/formatDistance';
import formatRelative from 'date-fns/formatRelative';
import isSameDay from 'date-fns/isSameDay';
import isSameYear from 'date-fns/isSameYear';
import enUS from 'date-fns/locale/en-US';

import { isBlank } from 'shared/lib/utils';

const LOCALES = {
  'en-US': enUS,
};

// e.g.: Mon, Aug 22nd 2016
export const DAY_OF_WEEK_MONTH_DAY_OF_MONTH_YEAR_FORMAT = 'E, MMM do yyyy';

// e.g.: Aug 22nd 2016
export const MONTH_DAY_OF_MONTH_YEAR_FORMAT = 'MMM do yyyy';

// e.g.: August 2016
export const MONTH_YEAR_FORMAT = 'MMMM yyyy';

// e.g.: 2016/8/22
export const YEAR_MONTH_DAY_FORMAT = 'yyyy-M-d';

export function formatStringAsDate(dateString, dateFormat, locale) {
  return formatAsDate(new Date(dateString), dateFormat, locale);
}

export function formatAsDate(date, dateFormat, locale) {
  return format(date, dateFormat, {
    locale: LOCALES[locale] || enUS,
  });
}

export function tweetLikeTimestamp(isoDateStr) {
  if (isBlank(isoDateStr)) {
    return null;
  }

  const now = new Date();
  const date = new Date(isoDateStr);

  if (isSameDay(date, now)) {
    return formatDistance(date, now, { addSuffix: true });
  } else if (isSameYear(date, now)) {
    return format(date, 'MMM d');
  } else {
    return format(date, 'MMM d, yyyy');
  }
}

const formatRelativeLocale = {
  today: "'today'",
  yesterday: "'yesterday'",
  lastWeek: "'last' eeee",
  tomorrow: "'tomorrow'",
  nextWeek: "'next' eeee",
  other: "'on' MMM do, yyyy",
};

export function formatRelativeFromNow(isoDateStr) {
  if (isBlank(isoDateStr)) {
    return null;
  }

  return formatRelative(new Date(isoDateStr), new Date(), {
    weekStartsOn: 1,
    locale: {
      ...enUS,
      formatRelative: (token) => formatRelativeLocale[token],
    },
  });
}
